import { Navigate, Outlet, useLocation } from "react-router-dom";
import TokenService from "services/TokenService";

const useAuth = () => {
  const location = useLocation();
  console.log(location.pathname);
  if (location.pathname.includes("complete-registration")) {
    TokenService.removeUser();
  } else {
    const user = localStorage.getItem("LoggedInUser");
    if (user) {
      return true;
    } else {
      return false;
    }
  }
};

const PublicRoutes = () => {
  const auth = useAuth();

  return auth ? <Navigate to="customers" /> : <Outlet />;
};

export default PublicRoutes;
